import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const StepNumber = ({ number }) => (
  <Box
    sx={{
      width: 20,
      height: 20,
      borderRadius: "50%",
      backgroundColor: "#2563EB",
      color: "#FFFFFF",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 11,
      fontWeight: 700,
      mr: 1,
      flexShrink: 0,
    }}
  >
    {number}
  </Box>
);

const Arrow = () => (
  <Typography sx={{ color: "#9CA3AF", mx: 1, fontSize: 13, userSelect: "none" }}>
    →
  </Typography>
);

const StatusPill = ({ label, color, dotColor }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      px: "6px",
      py: "2px",
      borderRadius: "4px",
      backgroundColor: color,
      fontSize: 12,
      fontWeight: 600,
      mx: "3px",
    }}
  >
    <Box
      sx={{
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: dotColor,
      }}
    />
    {label}
  </Box>
);

const EddProcessStepper = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        p: 2,
        px: 3,
        mb: 4,
        borderRadius: "8px",
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: "#FFFFFF",
        gap: 0.5,
        fontSize: 13,
        color: "text.primary",
      }}
    >
      <Box display="inline-flex" alignItems="center">
        <StepNumber number={1} />
        <Typography fontSize={13} fontWeight={500}>
          Upload CSV
        </Typography>
      </Box>

      <Arrow />

      <Box display="inline-flex" alignItems="center">
        <StepNumber number={2} />
        <Typography fontSize={13} fontWeight={500}>
          Server queues job
        </Typography>
      </Box>

      <Arrow />

      <Box display="inline-flex" alignItems="center">
        <StepNumber number={3} />
        <Typography fontSize={13} fontWeight={500}>
          Async validation + import
        </Typography>
      </Box>

      <Arrow />

      <Box display="inline-flex" alignItems="center">
        <StepNumber number={4} />
        <Typography fontSize={13} fontWeight={500} sx={{ mr: 0.5 }}>
          Status:
        </Typography>
        <StatusPill label="Completed" color="#DCFCE7" dotColor="#16A34A" />
        <StatusPill label="Partial" color="#FEF3C7" dotColor="#D97706" />
        <StatusPill label="Failed" color="#FEE2E2" dotColor="#DC2626" />
      </Box>

      <Arrow />

      <Box display="inline-flex" alignItems="center">
        <StepNumber number={5} />
        <Typography fontSize={13} fontWeight={500} color="text.secondary">
          Error report downloadable from GCS (if any)
        </Typography>
      </Box>
    </Box>
  );
};

export default EddProcessStepper;
